import { APP_LOGIN } from "../../store/constants/general";

export function doLogin(pinNumber = null) {
  return {
    type: APP_LOGIN,
    pinNumber
  };
}
